import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SalesLayout from './SalesLayout';
import SalesAuthGuard from './sales/SalesAuthGuard';
import AdminErrorBoundary from './admin/AdminErrorBoundary';
import SalesHome from './sales/SalesHome';
import SalesSOSearch from './sales/SOSearch';
import SalesClientSearch from './sales/ClientSearch';
import FacilitatorHoursView from './sales/FacilitatorHoursView';


const SalesDashboard = () => {
  return (
    <AdminErrorBoundary>
      <SalesAuthGuard>
        <SalesLayout>
          <Routes>
            {/* Default redirect to dashboard */}
            <Route path="/" element={<Navigate to="/sales/dashboard" replace />} />
            
            {/* Protected sales routes */}
            <Route path="/dashboard" element={<SalesHome />} />
            <Route path="/scheduled-offerings/search" element={<SalesSOSearch />} />
            <Route path="/clients" element={<SalesClientSearch />} />
            <Route path="/facilitator-hours" element={<FacilitatorHoursView />} />
            
            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/sales/dashboard" replace />} />
          </Routes>
        </SalesLayout>
      </SalesAuthGuard>
    </AdminErrorBoundary>
  );
};

export default SalesDashboard;